import { Component, OnInit, ViewChild, HostListener, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonService } from '@services/app.common.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { RoleAccessService } from '@services/role.access.service';
import { SecurityRoleDetail, ClientDivision } from '../../_models/settings/settingsModels';
import { UserInfo } from '../../_models/common/userInfo';
import { SecurityRoleItems, SecurityRoleMainMenu } from '../../_enums/securityRoleItems';
import { DataStorageService } from '@services/data-storage-service';
import { ShowHideAnimation } from '../../_animations/animations';
import { AlertService } from '@services/alert.service';
import { DataPassService } from '@services/app.datapass.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DeviceIdentificationService } from '@services/device-identification.service';
import { NotifiactionsDTO, DesktopNotify, NotificationCountDetail, HeaderMenu } from '../../_models/jobsAndTalents/jobsAndTalentsModels';
import { HeaderNotificationService } from '@services/headerNotification.service';
import { NotificationsComponent } from '../../../notifications/notifications.component';
import { FDMGraphType, FDMListingRouteUrl, FDMTlsType } from '../../_enums/fdm';
import { SSOType, StatusCode } from '../../_enums/Common';
import { ClientConfiguation } from '../../_enums/clientConfiguration';
import { FileInfo } from '../../_models/common/BaseModel';

import moment from 'moment-mini-ts';
import { EnhancedTaskService } from '@services/enhancedTask.service';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.css'],
    animations: [
        ShowHideAnimation
    ],
    standalone: false
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @ViewChild(NotificationsComponent, { static: true }) headerNotification?: NotificationsComponent;
  public IsEnableRightInfoShow = false;
  public IsEnableLeftInfoShow = false;
  public totalNotifications = 0;
  @ViewChild('HelpAndSupport', { static: true }) helpAndSupport?: ModalDirective;
  @ViewChild('dro') outside?: ElementRef;
  public notification = {} as NotifiactionsDTO;
  public permission = {} as DesktopNotify;
  public QuickLinksLogoAndNotifications: any;
  public quickLinks: any;
  public trafficLightCount: any;
  public FDMTlsType = FDMTlsType;


  public activeRightSideMenu = false;
  public settingMenuClasses = 'user-sub-nav';
  public activeLeftSideMenu = false;
  public activeSearchMenu = false;
  public activeNotifications = 'nav-item';
  public showNotifications = false;
  public activeTalentMenu = false;
  public desktopItems: DesktopItem[] = [];
  public userInfo = {} as UserInfo;
  public accessType = 'Access';
  public SecurityRoleDetail = {} as SecurityRoleDetail;
  public SecurityRoleItems = SecurityRoleItems;
  public activeMenu = 1;
  public knowledgeHubLink = 'https://jobtrain.co.uk/jobtrain-info-hub/';
  public helpDeskLink = 'https://knowledge.jobtrain.co.uk/client';
  public rightInfoAnimation = 'hide';
  public leftInfoAnimation = 'hide';
  public GraphDataType = '';
  public Unallocated = '';
  public toolTip = '';
  public Allocated = '';
  public Reminders = '';
  public fdmClient = 0;
  public ReminderY = 0;
  public ReminderR = 0;
  public ReminderB = 0;
  public AllocatedG = 0;
  public AllocatedR = 0;
  public AllocatedY = 0;
  public UnAllocatedO = 0;
  public isLeftMenuOpenClick = false;
  public IsJTGO = false;
  public HelpAndSupportShow = true;

  public isHideSettingsIcon = false;
  public isDashbaordAllow = false;
  public isSearchAllowed = false;
  public isJobAllowed = false;
  public isReportAllowed = false;
  public isMyReportAllowed = false;
  public isCalenderAllowed = false;
  public isTalentAllowed = false;
  public isSettingsAllowed = false;
  public isTalentPoolAllowed = false;
  public isFeatureCRM = false;
  public isFeatureRedeployment = false;
  public isTalentCaptureAllowed = false;
  public isTalentCommunityAllowed = false;
  // public leftInfoDashboardAnimation = "show";
  public isDashboard = false;
  public isSmallDevice = false;
  public isFDMNotification = false;
  public showMobileMenu = false;
  public clientDivision = {} as ClientDivision;
  public quickLinkLogo: any;
  private $subscription: Subscription = Subscription.EMPTY;;
  private $notificationSubscription: Subscription = Subscription.EMPTY;;
  private $securityRoleChangedSubscription: Subscription = Subscription.EMPTY;;
  private $fdmNotificationsubscription: Subscription = Subscription.EMPTY;;
  public bannerMessage?: string;
  public banner: string = '';
  public bannerNavIcon: string = '';
  public cookieBannerBottom: string = '';
  public bannerQuickmenu: string = '';
  public clientIdentifier: string = "";
  public newWindow = '0';
  public showTopHeader = true;
  public featureStripe: boolean = false;
  public featureNylas: boolean = false;
  public featureNylasPersonalAccount: boolean = false;
  public featureNylasCorporateAccount: boolean = false;
  personalAccountPermission: boolean = false;
  corporateCalendarPermission: boolean = false;
  corporateInboxPermission: boolean = false;
  featureMyTasks: boolean = false;
  enhancedNotificationCount: number = 0;

   talentMenuUrl = [
    'JobsAndTalents/Jobs/Talents',
    'JobsAndTalents/TalentCapture',
    'JobsAndTalents/crm-talent-pool/talent-network-list',
    'JobsAndTalents/crm-talent-pool/talent-pool-list',
     'crm-talent-pool/talent-pool-alert-list',
     'JobsAndTalents/crm-talent-pool/talent-pool-candidate-list',
    'JobsAndTalents/redeployment/cases'
  ];

  isOBNotifitionsAllowed: boolean = false;
  activeReportMenu: boolean = false;
  isReportBuilderAllowed: boolean = false;
  featureReportBuilder: boolean = false;
  public hasAdvertisingPartnerAccess  = false;
  public isAdvertisingPartnerEnabled = false;
  private readonly notificationCacheMs = 600000;


  public featureAdvanceDashboard: boolean = false;
    constructor(private route: ActivatedRoute, private router: Router, private render: Renderer2, private datapass: DataPassService, private alertService: AlertService, public common: CommonService, public roleService: RoleAccessService, public dataStorage: DataStorageService, private el: ElementRef, private _sanitizer: DomSanitizer, private deviceIdentificationService: DeviceIdentificationService, private headerNotificationService: HeaderNotificationService, private enhancedTaskService: EnhancedTaskService) {
      this.userInfo = this.common.GetLoggedinUserInfo();
      this.SetAccessVariables();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.newWindow = params['NewWindow'];
      if (this.newWindow == '1') {
        this.showTopHeader = this.newWindow == '1' ? false : true;
        this.render.addClass(document.body, 'jt-modal-window-open');
      }
      this.toolTip = this.common.GetTranslation('Common.QuickLinksToolTip');
      this.IsJTGO = this.common.getJTGO();
      this.featureStripe = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.FeatureStripe));
      
    });
    this.hasAdvertisingPartnerAccess = this.roleService.HasAccess(SecurityRoleItems.AdvertisingPartnerAccess);
    if (this.hasAdvertisingPartnerAccess) {
      this.isAdvertisingPartnerEnabled = this.roleService.HasAccess(SecurityRoleItems.IsAdvertisingPartnerEnabled);
    }
    this.featureMyTasks = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.featureMyTasks));
    this.featureNylas = this.roleService.HasAccess(SecurityRoleItems.Feature_Nylas);
    this.featureNylasPersonalAccount = this.common.getBoolean(this.common.readClientConfiguration(SecurityRoleItems.Feature_Nylas_Personal_Account));
    this.featureNylasCorporateAccount = this.common.getBoolean(this.common.readClientConfiguration(SecurityRoleItems.Feature_Nylas_Corporate_Account));
    this.personalAccountPermission = this.roleService.HasAccess(SecurityRoleItems.PersonalAccount);
    this.corporateCalendarPermission = this.roleService.HasAccess(SecurityRoleItems.CorporateCalendar);
    this.corporateInboxPermission = this.roleService.HasAccess(SecurityRoleItems.CorporateInbox);

    if (this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.ShowObV2))) {
      this.isOBNotifitionsAllowed = this.roleService.HasAccess(SecurityRoleItems.Compliance_OnBoardingNotifications);
    }
    this.featureAdvanceDashboard = this.common.getBoolean(this.common.readClientConfiguration(SecurityRoleItems.FeatureAdvanceDashboard));

    this.featureReportBuilder = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.FeatureReportBuilder));


    this.$notificationSubscription = this.headerNotificationService.HeaderNotificationCount().subscribe(samllDevice => {
      this.NotificationUpdateByService();
    });

    this.$securityRoleChangedSubscription = this.headerNotificationService.onSecurityRoleChanged().subscribe(samllDevice => {
      this.SetAccessVariables();
    });
    
    this.enhancedTaskService.notificationChanged$.subscribe(() => {
      this.enhancedTaskService.getEnhancedNotifications().then(count => { this.enhancedNotificationCount = count;});
    });

    this.$subscription = this.deviceIdentificationService.getIsSmallDevice().subscribe(samllDevice => {
      // close menu for samll devices and open for larger devices
      // isSmallDevice:boolean
      // isSmallDevice=true in case of mobile
      this.isSmallDevice = samllDevice;
      if (this.isSmallDevice) {


        setTimeout(() => {
          this.activeLeftSideMenu = true;
          this.openNav();
        }, 500);


      } else {

        setTimeout(() => {
          this.activeLeftSideMenu = false;
          this.openNav();
        }, 500);
      }
    });


    this.$fdmNotificationsubscription = this.headerNotificationService.GetFDMQuickLinkNotification().subscribe(isFDMNotification => {

      this.isFDMNotification = isFDMNotification;
      if (this.isFDMNotification) {
        this.common.RemoveLocalStorage('QuickLinks');
        this.GetQuickLinks();
      }

    });



    if (this.common.readClientConfiguration(ClientConfiguation.TopMenuDisableHelpLink) == 'yes') {
      this.HelpAndSupportShow = false;
    } else {
      this.HelpAndSupportShow = true;
    }


    if (this.roleService.HasAccess(SecurityRoleItems.FeatureFDM)) {
      this.GetTrafficLightCount();
    }

      if (!this.featureAdvanceDashboard && (this.IsHomePage() || this.checkEnhancedNotification())) {
      this.isDashboard = true;
    }
    this.setActiveMenuByCurrentUrl();
    this.GetPlatformAnnouncements();

    this.GetQuickLinks();

    this.GetQuickLinksLogo();
    this.LoadDynamicStyles();
    this.activeMenu = parseInt(this.common.GetFromLocalStorage('active_menu_index'));
    this.clientIdentifier = this.common.clientIdentifier;
    if (this.featureMyTasks) {
      this.enhancedTaskService.notifyOnNotificationChanged();
    }
  }


  public helpSuppor() {
    if (jQuery('#walkme-player').length > 0) {
      jQuery('#walkme-player').click();
    } else {
      this.helpAndSupport?.show();
    }
  }
  public closeHelp() {
    this.helpAndSupport?.hide();
  }
  public ContactSelect() {
    this.setActiveMenu('8');
    this.common.NavigateToRoute(this.common.RouteUrls.HelpAndSupport.ContactSelect);
    this.helpAndSupport?.hide();

  }
  public openSettingMenu() {
    if (this.settingMenuClasses == 'user-sub-nav') {
      this.settingMenuClasses = 'user-sub-nav open-menu';
    } else {
      this.settingMenuClasses = 'user-sub-nav';
    }
    return false;
  }
  public navigateTo() {
    this.router.navigate(['Home']);
  }
  public GetQuickLinks() {
    var obj = this.common.GetFromLocalStorage("QuickLinks");
    if (obj) {
      this.quickLinks = this.common.JsonParseData(obj);
      this.ProcessQuicklinks(this.quickLinks);
    }
    else {
      this.common.GetData(this.common.ApiUrls.HomePage.GetQuickLinks, false).then(data => {
        if (data) {
          this.ProcessQuicklinks(data);
        }
      });
    }
  }
  ProcessQuicklinks(data: any) {
    this.common.SetLocalStorage('QuickLinks', JSON.stringify(data));
    this.desktopItems = data.resultData.desktopItems;
    this.trafficLightCount = data.resultData.trafficLightCount;
    var outerThis = this;
    if (this.desktopItems.length > 0) {
      this.desktopItems.forEach(function (item) {
        if (item.jT7ItemURL == "/Settings/Emails/PersonalInbox" || item.jT7ItemURL == "/Settings/Calendar/Personal") {
          if (!outerThis.featureNylas || !outerThis.featureNylasPersonalAccount || !outerThis.personalAccountPermission) {
            outerThis.desktopItems = outerThis.desktopItems.filter(d => d.jT7ItemURL != item.jT7ItemURL)
          }
        }
        if (item.jT7ItemURL == "/Settings/Emails/Inbox" ) {
          if (!outerThis.featureNylas || !outerThis.featureNylasCorporateAccount || !outerThis.corporateInboxPermission) {
            outerThis.desktopItems = outerThis.desktopItems.filter(d => d.jT7ItemURL != item.jT7ItemURL)
          }
        }
        if (item.jT7ItemURL == "/Settings/Calendar/Corporate") {
          if (!outerThis.featureNylas || !outerThis.featureNylasCorporateAccount || !outerThis.corporateCalendarPermission) {
            outerThis.desktopItems = outerThis.desktopItems.filter(d => d.jT7ItemURL != item.jT7ItemURL)
          }
        }

      })
    }
    this.fdmClient = data.resultData.fdm_Client;
    this.dataStorage.setData(data.resultData);
  };
  public GetTrafficLightCount() {
    this.common.GetData(this.common.ApiUrls.HomePage.GetTrafficLightCount, false).then(data => {
      if (data) {
        this.trafficLightCount = data.resultData.trafficLightCount;
      }
    });
  }

  public GetQuickLinksLogo() {
    const obj = this.common.GetFromLocalStorage('QuickLinksLogoAndNotifications_' + this.userInfo.id);
    if (obj) {
      this.QuickLinksLogoAndNotifications = this.common.JsonParseData(obj);
      this.SetQuickLinksLogo(this.QuickLinksLogoAndNotifications,true);
    } else {
      this.common.GetData(this.common.ApiUrls.QuickLink.GetQuickLinksLogoAndNotifications, false).then(data => {
        if (data) {
          this.common.SetLocalStorage('QuickLinksLogoAndNotifications_' + this.userInfo.id, JSON.stringify(data));
          this.SetQuickLinksLogo(data,false);
        }
      });
    }
  }


  public LoadDynamicStyles() {
    const styles = this.common.GetFromLocalStorage('DynamicStyles');
    if (!this.common.isNullOrWhiteSpace(styles)) {
      this.AppendDynamicStyles();
    } else {
      this.common.GetData(this.common.ApiUrls.SystemSettings.GetDynamicStyles, false).then(res => {
        if (res.status == StatusCode.OK) {
          let styles = res.resultData[0];
          if (styles != null) {
            styles = styles.style;
          }
          this.common.SetLocalStorage('DynamicStyles', styles);
          this.AppendDynamicStyles();
        }
      });
    }
  }
  public AppendDynamicStyles() {

    setTimeout(() => {
      const styles = this.common.GetFromLocalStorage('DynamicStyles');
      try {

        const styleSheet = document.createElement('style');
        styleSheet.innerHTML = styles;
        styleSheet.id = 'client_styles';
        document.head.appendChild(styleSheet);
      } catch (ex) {
        console.error('Error appending client styles');
        console.error(ex);
      }
    }, 1000);



  }

  SetQuickLinksLogo(data: any, isFromLocalStorage: boolean) {

    this.clientDivision = this.common.JsonParseData(data.clientDivision);
    var obj = this.common.JsonParseData(data.notification);
    let totalNotifications = 0;
    if (!this.common.isNullOrWhiteSpace(this.common.GetFromLocalStorage("TotalNotifications"))) {
      totalNotifications = parseInt(this.common.GetFromLocalStorage("TotalNotifications"))
    }
    if (totalNotifications > 0 && isFromLocalStorage)
    {
      this.totalNotifications = totalNotifications;
    }
    else if (obj.resultData && !isFromLocalStorage) {
      this.notification = obj.resultData;
      if (this.notification) {
         this.setTotalNotificationCount();
      }
    }
    if (this.clientDivision != null) {
      const fileInfo = {} as FileInfo;
      fileInfo.content = this.clientDivision.logoUrl;
      fileInfo.name = this.clientDivision.logo_FileName;
      fileInfo.extention = this.clientDivision.logoType;
      const quickLinksLogo = this.common.FileURL(fileInfo);
      this.quickLinkLogo = this.clientDivision.logoUrl != '' ? this._sanitizer.bypassSecurityTrustResourceUrl(quickLinksLogo) : '';
    }

  }

  public openNav() {
    try {
      
      if (this.activeLeftSideMenu == true) {
        document.getElementById('HomePageMain')?.setAttribute('class', 'HomePageMain');
        this.activeLeftSideMenu = false;
          if (this.isDashboard && (this.IsHomePage() || this.checkEnhancedNotification())) {
          let quickNav = document.getElementById('quick-nav');
          if (quickNav)
            quickNav.style.width = '0px';
          let main = document.getElementById('main');
          if (main)
            main.style.paddingLeft = '0';
          let mainQuickNav = document.getElementById('mian-quick-nav');
          if (mainQuickNav)
            mainQuickNav.style.width = '0';

          document.body.classList.remove('quick-link-active');
        }
      } else {
        document.getElementById('HomePageMain')?.setAttribute('class', 'HomePageMain home_MainPage-side-active');
        this.activeLeftSideMenu = true;
          if (this.isDashboard && (this.IsHomePage() || this.checkEnhancedNotification())) {
          let mainQuickNav = document.getElementById('mian-quick-nav');
          if (mainQuickNav)
            mainQuickNav.style.width = '250px';
          let quickNav = document.getElementById('quick-nav');
          if (quickNav)
            quickNav.style.width = '250px';
          let main = document.getElementById('main');
          if (main)
            main.style.paddingLeft = '250px';

          document.body.classList.add('quick-link-active');
        }
      }
    } catch (e) {

    }
    this.showMobileMenu = false;
  }

  public SetAccessVariables() {
    const accessType = 'Access';
    this.isDashbaordAllow = this.roleService.HasAccess(SecurityRoleItems.Dashboard);
    this.isSearchAllowed = this.roleService.HasMainMenuAccess(SecurityRoleMainMenu.Search);
    this.isCalenderAllowed = this.roleService.HasMainMenuAccess(SecurityRoleMainMenu.Calendar);
    this.isSettingsAllowed = this.roleService.HasMainMenuAccess(SecurityRoleMainMenu.SettingsControl);
    this.isJobAllowed = this.roleService.HasAccess(SecurityRoleItems.Jobs);
    this.isReportAllowed = this.roleService.HasAccess(SecurityRoleItems.Reports);
    this.isMyReportAllowed = this.roleService.HasAccess(SecurityRoleItems.MyReports);
    this.isHideSettingsIcon = this.roleService.HasAccess(SecurityRoleItems.HideSettingsIcon);

    //check access for talent menue
    this.isFeatureCRM = (this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.FeatureCRM)) && this.roleService.HasAccess(SecurityRoleItems.TalentPool));
    this.isFeatureRedeployment = this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.featureRedeployment)) && this.roleService.HasAccess(SecurityRoleItems.RedeploymentCases) && this.userInfo.isUserRedeploymentManager;
    this.isTalentPoolAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentPool);
    this.isTalentCaptureAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentCapture);
    this.isTalentCommunityAllowed = this.roleService.HasAccess(SecurityRoleItems.TalentCommunity);
    if (this.isTalentCaptureAllowed  || this.isTalentPoolAllowed || this.isTalentCommunityAllowed || this.isFeatureCRM || this.isFeatureRedeployment) {
      this.isTalentAllowed = true;
    }
    this.isReportBuilderAllowed = this.roleService.HasAccess(SecurityRoleItems.ReportBuilder);



  }

  RightInfoShow() {
    this.IsEnableRightInfoShow = true;

    if (this.rightInfoAnimation == 'hide') {
      this.rightInfoAnimation = 'show';

    }
  }

  LeftInfoShow() {

    this.showMobileMenu = false;
    this.IsEnableLeftInfoShow = true;
    this.isLeftMenuOpenClick = true;
    this.leftInfoAnimation = 'show';
  }
  setActiveMenu(index: string) {
    
    this.common.RemoveAllSessionStorage();
    this.common.SetLocalStorage('active_menu_index', index);
    this.activeMenu = parseInt(index);

    if (index == '2' || index == '3') {
      this.activeMenu = parseInt(index);
    }
     if (index === '4') {
      this.activeReportMenu = !this.activeReportMenu;
    }
  }
  setActiveMenuByCurrentUrl() {
    this.activeMenu = parseInt(this.common.GetFromLocalStorage('active_menu_index'));
    const url = window.location.href;
    let index = '1';
    if (url.indexOf('JobsAndTalents') > -1) {
      index = '2';

      this.talentMenuUrl.forEach(substring => {
        if (url.indexOf(substring) > -1) {
          index = '3';
        }
      });

    }
    else if (url.indexOf('WorkPlace/MyCandidateAlert') > -1) {
      index = '3';
    }
    else if (url.indexOf('WorkPlace/MySavedAlert') > -1) {
      index = '3';
    }

    else if (this.IsHomePage()) {
      index = '1';
    } else if (url.indexOf('Reports') > -1 || url.indexOf('ReportBuilder') > -1) {
      index = '4';
    } else if (url.indexOf('Search') > -1) {
      index = '5';
    } else if (url.indexOf('Settings') > -1) {
      index = '6';
    } else if (url.indexOf('HelpAndSupport') > -1) {
      index = '8';
    } else if (url.indexOf('Calendar') > -1) {
      index = '10';
    } else if (url.indexOf('Communications') > -1) {
      index = '6';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 1) {
      index = '1';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 2) {
      index = '2';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 3) {
      index = '3';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 4) {
      index = '4';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 5) {
      index = '5';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 6) {
      index = '6';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 8) {
      index = '8';
    } else if (url.indexOf('Shared') > -1 && this.activeMenu == 10) {
      index = '10';
    }

    if (this.featureAdvanceDashboard && this.common.GetFromLocalStorage('landingpage-active_menu_index')==='1') {
      this.activeMenu = parseInt(this.common.GetFromLocalStorage('landingpage-active_menu_index'));
      this.common.SetLocalStorage('active_menu_index', '1');
    }
    else
      this.common.SetLocalStorage('active_menu_index', index);

  }
  navigateToMenu(index: string, path: string) {
    
    if (this.featureAdvanceDashboard && !this.common.isNullOrWhiteSpace(this.common.GetFromLocalStorage("landingPageUrl")) && index==='1') {
      this.navigateToLandingPage(index)
    }
    else
    {
      this.common.RemoveLocalStorage('landingpage-active_menu_index');
      this.setActiveMenu(index);
      if (index == '3' || index == '5') {
        this.activeMenu = parseInt(index);
      }

      setTimeout(() => { this.common.NavigateToRoute(path); }, 100);
    }
  }
  byClickOnMenu(eventData: HeaderMenu) {
    this.navigateToMenu(eventData.index, eventData.path)
  }
  openSearchMenu(ele: string) {
    this.activeSearchMenu == true ? this.activeSearchMenu = false : this.activeSearchMenu = true;
  }

  @HostListener('document:click', ['$event']) clickedOutside($event: any) {
    if (event?.target) {
      const targetElement = event.target as HTMLElement;
      const parentElement = targetElement.parentElement;

      if (parentElement != null) {
        if (parentElement.id != 'dropdownSearch' && parentElement.id != 'dropdownSearchsvg' && parentElement.id != 'dropdownSearchli') {
          this.activeSearchMenu = false;
        }
        if (parentElement.id != 'notificationsli' && !$event.target.closest('#MynotificationsAlert')
          && parentElement.id != 'notificationsAnchor' && parentElement.id != 'notificationsSvg' && !$event.target.closest('#notificationsAnchor')) {
          this.showNotifications = false;
          this.activeNotifications = 'nav-item';
        }

        if (parentElement.id != 'RightSideMenu') {
          this.rightMenuClose();
        }
        if (parentElement.id != 'LeftSideMenu') {
          if (!this.isLeftMenuOpenClick) {
            this.leftInfoClose();
          } else {
            this.isLeftMenuOpenClick = false;
          }
        }

      }
      if (targetElement.id != 'dropdownTalent') {
        this.activeTalentMenu = false;
      }
      if (targetElement.id != 'headerReports') {
        this.activeReportMenu = false;
      }
    }
  }

  displayUserLogo() {
    let logoText = '';
    // userInfo.firstName.substring(0, 1).toUpperCase()
    if (this.userInfo != null) {
      if (this.userInfo.firstName) {
        if (this.userInfo.firstName.length > 1) {
          logoText += this.userInfo.firstName.substring(0, 1).toUpperCase();
        }
      }
      if (this.userInfo.lastName) {
        if (this.userInfo.lastName.length > 1) {
          logoText += this.userInfo.lastName.substring(0, 1).toUpperCase();
        }
      }
    }
    return logoText;
  }

  public leftInfoClose() {

    this.IsEnableLeftInfoShow = false;
    this.isLeftMenuOpenClick = false;

    this.leftInfoAnimation = 'hide';

  }

  public rightMenuClose() {
    this.IsEnableRightInfoShow = false;

    if (this.rightInfoAnimation == 'show') {
      setTimeout(() => this.rightInfoAnimation = 'hide');
    }
  }

  public toggleMobileMenu() {

    if (this.showMobileMenu == true) {
      this.showMobileMenu = false;
    } else {
      this.showMobileMenu = true;
    }

    this.IsEnableLeftInfoShow = false;
    this.activeLeftSideMenu = false;

    document.getElementById('HomePageMain')?.setAttribute('class', 'HomePageMain');
    this.activeLeftSideMenu = false;
    if (this.IsHomePage()) {
      let quickNav = document.getElementById('quick-nav');
      if (quickNav)
        quickNav.style.width = '0px';
      let main = document.getElementById('main');
      if (main)
        main.style.paddingLeft = '0';
      let mainQuickNav = document.getElementById('mian-quick-nav');
      if (mainQuickNav)
        mainQuickNav.style.width = '0';
    }


  }
  IsHomePage() {
    const segments = window.location.pathname
      .split('/')
      .filter(Boolean)
      .map(s => s.toLowerCase());

    return segments[segments.length - 1] === 'home';
  }
  ShowHideNotifications() {
    if (this.featureMyTasks) {
      this.common.NavigateToRoute(this.common.RouteUrls.HomePage.EnhancedNotification);
      return;
    }
    this.activeNotifications = this.activeNotifications == 'nav-item active' ? 'nav-item' : 'nav-item active';
    this.showNotifications = !this.showNotifications;

  }
  public Navigate(desktopItem: DesktopItem) {
    if (desktopItem.isExternal != null && desktopItem.isExternal == true) {
      window.open(desktopItem.jT7ItemURL, '_blank');
    } else {
      desktopItem.itemTitle == 'Applicant Stats' ? this.common.NavigateToRouteWithQueryString(desktopItem.jT7ItemURL, { queryParams: { ApplicationStatusId: 2 } }) : this.common.NavigateToRoute(desktopItem.jT7ItemURL);
    }
  }

  public NavigateWithTlS(desktopItem: DesktopItem, tlsType: number) {

    let url = '';
    const tlsTypeQuerystring = '?tlsType=' + tlsType;
    if (desktopItem.graphDataType == FDMGraphType.Unallocated) {
      url = FDMListingRouteUrl.Unallocated;
    } else if (desktopItem.graphDataType == FDMGraphType.Allocated) {
      url = FDMListingRouteUrl.Allocated;
    } else if (desktopItem.graphDataType == FDMGraphType.Reminder) {
      url = FDMListingRouteUrl.Reminder;
    } else if (desktopItem.graphDataType == FDMGraphType.New) {
      url = FDMListingRouteUrl.New;
    }
    url = url + tlsTypeQuerystring;
    this.router.navigateByUrl(url);

  }

  UpdateTotalNotifications(total: number) {
    this.totalNotifications = total;
  }

  NotificationUpdateByService() {
    this.common.GetData(this.common.ApiUrls.DashBoard.Notification, true).then(data => {
      if (data.status == StatusCode.OK) {
        this.common.RemoveLocalStorage('TotalNotifications');
        this.totalNotifications = 0;
        this.notification = data.resultData;
        this.permission = data.resultData.permission;
        if (this.notification) {
          this.setTotalNotificationCount();
        }
      }
    });
  }

  GetPlatformAnnouncements() {
    const cacheKey = 'clientNotification';
    const cacheExpiryKey = 'clientNotificationExpiry';
    const expiry = this.common.GetFromLocalStorage(cacheExpiryKey);
    if (expiry && Date.now() < Number(expiry)) {
      const cachedResult = this.common.GetFromLocalStorage(cacheKey);
      if (cachedResult) {
        this.showNotificationBanner(JSON.parse(cachedResult));
        return;
      }
    }

    this.common.GetData(this.common.ApiUrls.HomePage.GetPlatformAnnouncements).then(data => {
      const result = data.resultData;
      if (result) {
        this.showNotificationBanner(result);
        this.common.SetLocalStorage(cacheKey, JSON.stringify(result));
        this.common.SetLocalStorage(cacheExpiryKey, (Date.now() + this.notificationCacheMs).toString());
      }
      else {
        this.hideNotificationBanner();
      }
    })
  }

  private showNotificationBanner(result: any): void {
    this.bannerMessage = result.msgDetails?.trim() ? result.msgDetails : undefined;
    if (this.common.isNullOrWhiteSpace(this.bannerMessage)) {
      this.banner = '';
      this.bannerNavIcon = '';
      this.cookieBannerBottom = '';
      this.bannerQuickmenu = '';
      this.render.removeClass(document.body, 'has-announcement-banner');
      return;
    }
    this.banner = 'cookie-banner';
    this.bannerNavIcon = 'cookie-banner-navicon';
    this.cookieBannerBottom = 'cookie-banner-bottom';
    this.bannerQuickmenu = 'cookie-quickmenu';
    this.render.addClass(document.body, 'has-announcement-banner');
  }

  private hideNotificationBanner(): void {
    this.bannerMessage = undefined;
    this.banner = '';
    this.bannerNavIcon = '';
    this.cookieBannerBottom = '';
    this.bannerQuickmenu = '';
    this.render.removeClass(document.body, 'has-announcement-banner');
  }

  ngOnDestroy() {
    if (this.$notificationSubscription) {
      this.$notificationSubscription.unsubscribe();
    }
    if (this.$subscription) {
      this.$subscription.unsubscribe();
    }
    if (this.$fdmNotificationsubscription) {
      this.$fdmNotificationsubscription.unsubscribe();
    }
    if (this.$securityRoleChangedSubscription) {
      this.$securityRoleChangedSubscription.unsubscribe();
    }

    this.render.removeClass(document.body, 'jt-modal-window-open');
    this.render.removeClass(document.body, 'has-announcement-banner');
  }

  contractUs() {
    this.common.NavigateToRoute('HelpAndSupport/ContactSelect');
  }

  public goToKnowledge_hub() {
    const knowledgeHubUrl = this.common.readClientConfiguration(ClientConfiguation.Helpdesk_KnowledgeHub);
    window.open(!this.common.isNullOrWhiteSpace(knowledgeHubUrl) ? knowledgeHubUrl : this.helpDeskLink, '_blank');
  }

  public goToHelpDesk() {

    const helpDeskUrl = this.common.readClientConfiguration(ClientConfiguation.Helpdesk_Link);
    if (!this.common.isNullOrWhiteSpace(helpDeskUrl)) {
      this.helpDeskLink = helpDeskUrl;
    }
    window.open(this.helpDeskLink, '_blank');

  }

  public jobTrainHelpDesk() {
    window.location.href = this.helpDeskLink;
  }
  sendTo(index: string, path: string) {
    this.common.RemoveLocalStorage('landingpage-active_menu_index');
    this.setActiveMenu(index);
    if (index == '3' || index == '5') {
      this.activeMenu = parseInt(index);
    }
    setTimeout(() => { this.common.NavigateToRoute(path); }, 100);
  }

  public logOut() {
    this.common.logOut();
  }
  setTotalNotificationCount() {
    const notificationCount: NotificationCountDetail = {
      candidateCount: 0,
      smsCount: 0,
      emailCount: 0,
      authCount: 0,
      obTotal: 0
    };
      if (this.notification.permission) {
        this.permission = this.notification.permission;
        if (this.common.LowerCase(this.permission.isCandidates) == 'yes') {
          notificationCount.candidateCount = this.notification.nmStatuses;
          this.totalNotifications += this.notification.nmStatuses;
        }
        if (this.common.LowerCase(this.permission.isJobs) == 'yes') {
          notificationCount.smsCount = this.notification.nmOfSMS;
          this.totalNotifications += this.notification.nmOfSMS;
        }
        if (this.common.LowerCase(this.permission.isJobs) == 'yes') {
          notificationCount.emailCount = this.notification.nmOfEmail;
          this.totalNotifications += this.notification.nmOfEmail;
        }
        if (this.common.LowerCase(this.permission.isAuthoriseJob) == 'yes' || this.common.LowerCase(this.permission.isAuthoriseCandidate) == 'yes') {
          notificationCount.authCount = this.notification.nmOfAutho;
          this.totalNotifications += this.notification.nmOfAutho;
        }
        if (this.roleService.HasAccess(SecurityRoleItems.Compliance_OnBoardingNotifications)) {
          notificationCount.obTotal = this.notification.obTotal;
          this.totalNotifications += this.notification.obTotal;
        }

      }
      this.common.SetLocalStorage('TotalNotifications', this.totalNotifications);
      this.common.SetLocalStorage('NotificationCount', JSON.stringify(notificationCount));
  }
  navigateToLandingPage(index: string): void {
    const path = this.common.GetFromLocalStorage("landingPageUrl");
    setTimeout(() => { this.common.NavigateToRoute(path); }, 100);
    if (index === '1') {
      this.activeMenu = parseInt(index);
      this.common.SetLocalStorage('landingpage-active_menu_index', index);

    }
  }

  checkEnhancedNotification() {
    return this.featureMyTasks && window.location.href.indexOf('/Notifications') > -1;
  }
  createAdvertisingPartnerSsoSession() {
    const tab = window.open('', '_blank');
    if (!tab) {
      this.common.Notification.error(this.common.GetTranslation('Messages.AdvertisingPartnerConnectionFailed'));
      return;
    }
    tab.opener = null;

    this.common.GetData(this.common.ApiUrls.AdvertisingPartner.CreateSsoSession, true).then(data => {
      if (data.status == StatusCode.OK && data.resultData) {
        tab.location.href = data.resultData;
      } else {
        tab.close();
        this.common.Notification.error(this.common.GetTranslation('Messages.AdvertisingPartnerConnectionFailed'));
      }
    });
  }  
}
export interface DesktopItem {
  id: number;
  itemTitle: string;
  itemType: string;
  graphDataType: string;
  jT7ItemURL: string;
  jT7SvgIcon: string;
  quickLinkLogo: string;
  logo_heght: string;
  logo_Width: string;
  isExternal: boolean;
  jT7Localization: string;
  dataTestId: string;
}

